import { Language } from '../contexts/LanguageContext';

export interface Translation {
  // Auth & Profile
  login: string;
  signup: string;
  logout: string;
  profile: string;
  name: string;
  email: string;
  password: string;
  confirmPassword: string;
  newPassword: string;
  updateProfile: string;
  profileUpdated: string;
  language: string;
  birthdate: string;
  birthdateFormat: string;
  birthday: string;
  birthdays: string;
  happyBirthdayGreeting: string;
  happyBirthdayGeneric: string;
  happyBirthdaySubtext: string;
  happyBirthdayCalendarPill: string;
  birthdayClose: string;
  holiday: string;
  holidays: string;
  holidayNewYearsDay: string;
  holidayMartinLutherKingJrDay: string;
  holidayPresidentsDay: string;
  holidayMemorialDay: string;
  holidayJuneteenth: string;
  holidayIndependenceDay: string;
  holidayLaborDay: string;
  holidayVeteransDay: string;
  holidayThanksgiving: string;
  holidayChristmasDay: string;
  emailNotEditable: string;
  amountPaid: string;
  amountDue: string;
  profilePicture: string;
  uploadProfilePicture: string;
  deleteProfilePicture: string;
  changeProfilePicture: string;
  profilePictureUploaded: string;
  profilePictureDeleted: string;
  profilePictureError: string;
  selectImage: string;
  confirmDeleteProfilePicture: string;
  yourContracts: string;

  // Navigation
  dashboard: string;
  home: string;
  schedule: string;
  classMaterials: string;
  adminPanel: string;
  manageUsers: string;
  manageSchedules: string;
  manageMaterials: string;
  contentLibrary: string;
  myContent: string;
  classPlans: string;
  attendance: string;

  // Content Library
  contentLibraryTitle: string;
  myContentTitle: string;
  myContentIntro: string;
  myContentEmpty: string;
  myContentEmptyDesc: string;
  myContentView: string;
  addContent: string;
  contentLibraryEmpty: string;
  contentLibraryEmptyDesc: string;
  contentLibraryAudience: string;
  allStudents: string;
  deleteContentConfirm: string;
  typeVideo: string;
  typeText: string;
  typeImage: string;
  loadMore: string;
  youtubeUrlPlaceholder: string;
  titleLabel: string;
  descriptionLabel: string;
  audienceLabel: string;
  contentLibraryComments: string;
  comments: string;
  addComment: string;
  reply: string;
  commentPlaceholder: string;
  noComments: string;
  commentEdited: string;
  commentDeleted: string;
  commentAuthorUnknown: string;
  you: string;

  // Dashboard
  quickActions: string;
  manageScheduleDesc: string;
  classMaterialsDesc: string;
  upcomingClasses: string;
  pastClasses: string;
  viewAll: string;
  yourUpcomingClasses: string;
  sunday: string;
  monday: string;
  tuesday: string;
  wednesday: string;
  thursday: string;
  friday: string;
  saturday: string;
  class: string;
  classes: string;
  noClassesScheduled: string;
  students: string;
  pair: string;
  group: string;
  calendar: string;
  previous: string;
  next: string;
  noUpcomingClasses: string;
  noPastClasses: string;
  paymentsDue: string;
  classOn: string;
  materials: string;
  slides: string;
  dayDetails: string;
  noDetailsAvailable: string;
  nothingScheduledForThisDay: string;
  days: string;
  markAbsent: string;
  absent: string;
  attendanceTitle: string;
  attendanceDescription: string;
  attended: string;
  missed: string;
  focusStudents: string;
  last7Days: string;
  last30Days: string;
  last90Days: string;
  dateRangeAll: string;
  sessionsCount: string;
  attendancePercent: string;
  studentsWithAbsences: string;
  atRisk: string;
  attendanceEmptyState: string;
  attendanceEmptyCta: string;
  onlyStudentsWithAbsences: string;

  // Schedule
  courseSchedule: string;
  scheduleDescription: string;
  previousMonth: string;
  nextMonth: string;
  weeklyScheduleSummary: string;
  studentsLabel: string;
  dayOfWeek: string;
  date: string;
  time: string;
  notes: string;
  notesInfo: string;
  privateNotes: string;
  privateNotesInfo: string;
  selectDayToViewDetails: string;
  availableClassDates: string;
  /** Fallback label when a slide URL cannot be parsed to a file name (modal buttons) */
  scheduleMaterialFileFallback: string;
  
  // Class Materials
  classMaterialsTitle: string;
  selectMonthLabel: string;
  selectDateLabel: string;
  selectClass: string;
  uploadMaterials: string;
  addLinkPlaceholder: string;
  uploading: string;
  existingMaterials: string;
  materialsForDate: string;
  selectDateWithClass: string;
  pleaseLogin: string;
  failedToLoad: string;
  usefulLinks: string;
  noMaterialsFound: string;
  downloadSlides: string;
  noMaterialsAvailable: string;
  addMaterials: string;
  
  // Common
  save: string;
  cancel: string;
  edit: string;
  delete: string;
  add: string;
  loading: string;
  error: string;
  success: string;
  saving: string;
  of: string;
  page: string;
  total: string;

  // Payment Configuration
  paymentConfiguration: string;
  weeklyInterval: string;
  selectPaymentDay: string;
  firstDayMonth: string;
  fifteenthDayMonth: string;
  lastDayMonth: string;
  pleaseSpecifyWeeklyInterval: string;
  pleaseSelectPaymentDay: string;
  paymentStartDate: string;
  addNewUser: string;
  onboardingChecklist: string;
  editOnboardingChecklist: string;
  onboardingChecklistEmpty: string;
  onboardingChecklistEmptyDesc: string;
  onboardingChecklistItemPlaceholder: string;
  addChecklistItem: string;
  saveChecklist: string;
  checklistSaved: string;
  failedToSaveChecklist: string;
  failedToLoadChecklist: string;
  studentOnboardingChecklist: string;
  checklistProgress: string;
  useLatestOnboardingChecklist: string;
  useLatestOnboardingChecklistInfo: string;
  noChecklistCreatedYet: string;
  generateSignupLink: string;
  paymentDue: string;
  weeklyPayment: string;
  monthlyPayment: string;
  paymentLink: string;
  addPaymentLink: string;
  noPaymentLink: string;
  amount: string;
  goToPaymentApp: string;
  paymentDueBannerOverdue: string;
  paymentDueBannerDueToday: string;
  paymentDueBannerDueSoon: string;
  paymentDueBannerViewDetails: string;
  paymentDueBannerPayNow: string;
  paymentStatusOverdue: string;
  paymentStatusDueToday: string;
  paymentStatusDueSoon: string;

  // Admin Payments
  paymentsDueDescription: string;
  selectPaymentsToSendEmails: string;
  selectAll: string;
  deselectAll: string;
  sendingEmails: string;
  sendEmails: string;
  noPaymentsDue: string;
  noPaymentsDueDescription: string;
  student: string;
  paymentSelected: string;
  paymentsSelected: string;
  readyToSendEmails: string;
  clearSelection: string;

  // Days of Week - Short Names
  sundayShort: string;
  mondayShort: string;
  tuesdayShort: string;
  wednesdayShort: string;
  thursdayShort: string;
  fridayShort: string;
  saturdayShort: string;

  // Admin Schedule
  manageClasses: string;
  addNewClass: string;
  createNewClass: string;
  dayAndTime: string;
  courseType: string;
  startDate: string;
  endDate: string;
  classStartDate: string;
  actions: string;
  optional: string;
  selectStudents: string;
  noStudentsAssigned: string;
  pending: string;
  unknownEmail: string;
  classNotFound: string;
  invalidField: string;
  updateSuccessful: string;
  updateFailed: string;
  noNotes: string;
  noEndDate: string;

  // Admin Users
  teacherAccount: string;
  adminAccount: string;
  enterFullName: string;
  enterEmailAddress: string;
  userStatus: string;
  activeUser: string;
  pendingSignup: string;
  copyLink: string;
  copySignupLink: string;
  confirmDelete: string;
  signupLinkCopied: string;
  signupLinkExpires: string;
  failedToCopyLink: string;
  pleaseEnterNameEmail: string;
  failedToGenerateLink: string;
  failedToFetchUsers: string;
  failedToDeleteUser: string;
  cannotDeleteOwnAccount: string;
  userNotFound: string;
  userDeleted: string;
  unauthorizedAction: string;
  pleaseEnterName: string;
  enterName: string;
  nameUpdated: string;
  failedToUpdateName: string;
  birthdateUpdated: string;
  failedToUpdateBirthdate: string;
  copy: string;

  // URL Validation
  invalidUrl: string;

  // Payment Completion
  completed: string;
  markAsCompleted: string;
  classSchedule: string;
  allPaymentsCompleted: string;
  markAsIncomplete: string;
  processing: string;
  paymentCompleted: string;
  completedOn: string;
  confirm: string;
  selectCompletionDate: string;

  // Admin Schedule Errors and Success Messages
  admin: {
    schedule: {
      errors: {
        selectStudent: string;
        addSchedule: string;
        monthlyPaymentDate: string;
        contractUpload: string;
        createClass: string;
        deleteClass: string;
      };
      success: {
        classCreated: string;
        classDeleted: string;
      };
      confirmDelete: string;
      pinnedLinks: string;
      pinnedLinksOptional: string;
      pinnedLinksDescription: string;
      addLink: string;
      pinnedLinkPlaceholder: string;
      pinnedLinkTitleLabel: string;
    };
  };

  linksPinnedByTeacher: string;
  usefulLinksForYou: string;
  opensInNewTab: string;

  // Timezones
  timezones: {
    eastern: string;
    central: string;
    mountain: string;
    pacific: string;
    brasilia: string;
    gmt: string;
    cet: string;
    msk: string;
    jst: string;
    cst: string;
    aet: string;
    local: string;
  };

  timezone: string;
  classTimesDisplayed: string;
  studentsSeeTimesConverted: string;
  onlySelectedDates: string;
  selectedFile: string;
  everyXNumberWeeks: string;
  onceAMonth: string;
  forMonthlyPayments: string;
  startDateMustBe1st15thOrLastDayOfMonth: string;

  paymentFrequency: string;
  every: string;
  week: string;
  weeks: string;
  autoSet: string;
  paymentDayAutoSet: string;
  enterURLWhereStudentsCanMakePayments: string;
  currency: string;
  currencyBRL: string;
  currencyUSD: string;
  currencyEUR: string;

  // Class Plans
  templateLibrary: string;
  noTemplatesAvailable: string;
  templateDescription: string;
  createTemplate: string;
  templateName: string;
  enterTemplateName: string;
  applyTemplate: string;
  applyToClassPlan: string;
  templateCreated: string;
  templateDeleted: string;
  templateUpdated: string;
  templateItems: string;
  noItemsInTemplate: string;
  topLevelItems: string;
  moreItems: string;
  createdBy: string;
  addFirstItem: string;
  noClassPlan: string;
  addNewItem: string;
  editItem: string;
  itemTitle: string;
  itemDescription: string;
  enterItemTitle: string;
  enterItemDescription: string;
  saveChanges: string;
  addChildItem: string;
  insertItemAbove: string;
  deleteClassPlan: string;
  deleteClassPlanWarning: string;
  deleteClassPlanConfirm: string;
  monthlyView: string;
  allPlans: string;
  selectStudent: string;
  noClassPlansExist: string;
  switchToMonthlyView: string;
  itemsCompleted: string;
  noItemsInPlan: string;
  addItemToGetStarted: string;
  planFor: string;
  insertAbove: string;
  expandCollapse: string;
  itemMarkedCompleted: string;
  itemMarkedIncomplete: string;
  templateApplied: string;
  itemAdded: string;
  itemUpdated: string;
  itemDeleted: string;
  childItemAdded: string;
  itemInserted: string;
  noTemplatesYet: string;
  templateReuse: string;
  editTemplate: string;
  viewTemplate: string;
  templateStructureNote: string;

  // Homework
  homework: string;
  addHomework: string;
  noHomework: string;
  homeworkTitle: string;
  homeworkDescription: string;
  allowTextSubmission: string;
  allowFileSubmission: string;
  submissionType: string;
  dueDate: string;
  noHomeworkAssignments: string;
  homeworkSubmissions: string;
  noSubmissionsYet: string;
  submittedOn: string;
  grade: string;
  feedback: string;
  submitFeedback: string;
  upcoming: string;
  past: string;
  upcomingHomework: string;
  pastHomework: string;
  noUpcomingHomework: string;
  noPastHomework: string;
  yourHomework: string;
  fileDeleted: string;
  deleteFile: string;

  // Class Exceptions
  exceptions: {
    cancelClass: string;
    rescheduleClass: string;
    cancelledClass: string;
    rescheduledFrom: string;
    rescheduledTo: string;
    rescheduledClass: string;
    reason: string;
    enterReason: string;
    newDateTime: string;
    selectNewDate: string;
    selectNewTime: string;
    confirmCancel: string;
    confirmReschedule: string;
    classCancelled: string;
    classRescheduled: string;
    deleteException: string;
    confirmDeleteException: string;
    exceptionDeleted: string;
    noExceptions: string;
    manageExceptions: string;
    originalDate: string;
    newDate: string;
    type: string;
    modifyClass: string;
  };
}

const translations: Record<Language, Translation> = {
  'en': {
    // Auth & Profile
    login: 'Login',
    signup: 'Sign Up',
    logout: 'Logout',
    profile: 'Profile',
    name: 'Name',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    newPassword: 'New Password',
    updateProfile: 'Update Profile',
    profileUpdated: 'Profile updated successfully',
    language: 'Language',
    birthdate: 'Birthdate',
    birthdateFormat: 'MM-DD',
    birthday: 'Birthday',
    birthdays: 'Birthdays',
    happyBirthdayGreeting: 'Happy birthday, {name}!',
    happyBirthdayGeneric: 'Happy birthday!',
    happyBirthdaySubtext: 'Wishing you a wonderful day!',
    happyBirthdayCalendarPill: 'Happy Birthday!',
    birthdayClose: 'Close',
    holiday: 'Holiday',
    holidays: 'Holidays',
    holidayNewYearsDay: "New Year's Day",
    holidayMartinLutherKingJrDay: 'Martin Luther King Jr. Day',
    holidayPresidentsDay: "Presidents' Day",
    holidayMemorialDay: 'Memorial Day',
    holidayJuneteenth: 'Juneteenth',
    holidayIndependenceDay: 'Independence Day',
    holidayLaborDay: 'Labor Day',
    holidayVeteransDay: 'Veterans Day',
    holidayThanksgiving: 'Thanksgiving',
    holidayChristmasDay: 'Christmas Day',
    emailNotEditable: 'Email cannot be edited. To change the email, the user must be deleted and recreated with the correct email.',
    amountPaid: 'Amount paid',
    amountDue: 'Amount due',
    profilePicture: 'Profile Picture',
    uploadProfilePicture: 'Upload Profile Picture',
    deleteProfilePicture: 'Delete Profile Picture',
    changeProfilePicture: 'Change Profile Picture',
    profilePictureUploaded: 'Profile picture uploaded successfully',
    profilePictureDeleted: 'Profile picture deleted successfully',
    profilePictureError: 'Error uploading profile picture',
    selectImage: 'Select Image',
    confirmDeleteProfilePicture: 'Are you sure you want to delete your profile picture?',
    yourContracts: 'Your Contracts',

    // Navigation
    dashboard: 'Dashboard',
    home: 'Home',
    schedule: 'Schedule',
    classMaterials: 'Class Materials',
    adminPanel: 'Admin Panel',
    manageUsers: 'Users',
    manageSchedules: 'Classes',
    manageMaterials: 'Manage Materials',
    contentLibrary: 'Content Library',
    myContent: 'My Content',
    classPlans: 'Study Plans',
    attendance: 'Attendance',
    contentLibraryTitle: 'Content Library',
    myContentTitle: 'My Content',
    myContentIntro: 'Content your teacher has shared with you.',
    myContentEmpty: 'Nothing shared yet',
    myContentEmptyDesc: 'Your teacher will add content here for you.',
    myContentView: 'View',
    addContent: 'Add content',
    contentLibraryEmpty: 'No content yet',
    contentLibraryEmptyDesc: 'Add videos, text, images, or links for your students to view.',
    contentLibraryAudience: 'Audience',
    allStudents: 'All students',
    deleteContentConfirm: 'Delete this item?',
    typeVideo: 'Video',
    typeText: 'Text',
    typeImage: 'Image',
    loadMore: 'Load more',
    youtubeUrlPlaceholder: 'Paste YouTube URL',
    titleLabel: 'Title',
    descriptionLabel: 'Description',
    audienceLabel: 'Who can see this',
    contentLibraryComments: 'Comments',
    comments: 'Comments',
    addComment: 'Add comment',
    reply: 'Reply',
    commentPlaceholder: 'Write a comment…',
    noComments: 'No comments yet',
    commentEdited: 'Edited',
    commentDeleted: '[Deleted]',
    commentAuthorUnknown: 'Unknown user',
    you: 'You',

    // Dashboard
    quickActions: 'Quick Actions',
    manageScheduleDesc: 'Create or edit class sessions',
    classMaterialsDesc: 'Upload and manage materials',
    upcomingClasses: "This Week's Upcoming Classes",
    pastClasses: "This Week's Past Classes",
    viewAll: 'View All',
    yourUpcomingClasses: 'Your Upcoming Classes',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    class: 'Class',
    classes: 'Classes',
    noClassesScheduled: 'No classes scheduled for this day',
    students: 'Students',
    pair: 'Pair Class',
    group: 'Group Class',
    calendar: 'Calendar',
    previous: 'Previous',
    next: 'Next',
    noUpcomingClasses: 'No upcoming classes',
    noPastClasses: 'No past classes',
    paymentsDue: 'Payments Due',
    classOn: 'Class on',
    materials: 'Materials',
    slides: 'Slides',
    dayDetails: 'Day Details',
    noDetailsAvailable: 'No details available',
    nothingScheduledForThisDay: 'There is nothing scheduled for this day.',
    days: 'Days',
    markAbsent: 'Mark absent',
    absent: 'Absent',
    attendanceTitle: 'Attendance',
    attendanceDescription: 'See who attended each session.',
    attended: 'Attended',
    missed: 'Missed',
    focusStudents: 'Focus on students',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    last90Days: 'Last 90 days',
    dateRangeAll: 'All',
    sessionsCount: 'Sessions',
    attendancePercent: 'Attendance %',
    studentsWithAbsences: 'Students with absences',
    atRisk: 'At risk',
    attendanceEmptyState: 'No attendance in this range. Mark absences on the Dashboard for class sessions.',
    attendanceEmptyCta: 'Mark absences on the Dashboard',
    onlyStudentsWithAbsences: 'Only students with at least one absence',
    
    // Schedule
    courseSchedule: 'Course Schedule',
    scheduleDescription: 'View and manage your class schedule.',
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month',
    weeklyScheduleSummary: 'Weekly Schedule Summary',
    studentsLabel: 'Students',
    dayOfWeek: 'Day',
    date: 'Date',
    time: 'Time',
    notes: 'Notes',
    notesInfo: 'Notes will be shared with students',
    privateNotes: 'Private notes',
    privateNotesInfo: 'Private notes will not be shared with students',
    selectDayToViewDetails: 'Select a day to view class details',
    scheduleMaterialFileFallback: 'Document',
    availableClassDates: 'Available class dates',
    linksPinnedByTeacher: 'Links pinned by your teacher',
    usefulLinksForYou: 'Useful links for you',
    opensInNewTab: 'opens in new tab',
    
    // Class Materials
    classMaterialsTitle: 'Class Materials Management',
    selectMonthLabel: 'Select Month',
    selectDateLabel: 'Select Date',
    selectClass: 'Select Class',
    uploadMaterials: 'Upload Materials',
    addLinkPlaceholder: 'Add a link to learning materials',
    uploading: 'Uploading...',
    existingMaterials: 'Existing Materials',
    materialsForDate: 'Materials for',
    selectDateWithClass: 'Select a date with a scheduled class to manage materials',
    pleaseLogin: 'Please log in to view your class materials.',
    failedToLoad: 'Failed to load class materials',
    usefulLinks: 'Useful Links',
    noMaterialsFound: 'No materials found',
    downloadSlides: 'Download Slides',
    noMaterialsAvailable: 'No materials available',
    addMaterials: 'Add materials',
    
    // Common
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    add: 'Add',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    saving: 'Saving...',
    of: 'of',
    page: 'Page',
    total: 'total',

    // Payment Configuration
    paymentConfiguration: 'Payment Configuration',
    weeklyInterval: 'Weekly Interval',
    selectPaymentDay: 'Payment Day',
    firstDayMonth: 'First day of month',
    fifteenthDayMonth: '15th of month',
    lastDayMonth: 'Last day of month',
    pleaseSpecifyWeeklyInterval: 'Please specify weekly interval',
    pleaseSelectPaymentDay: 'Please select payment day',
    paymentStartDate: 'Payment Start Date',
    addNewUser: 'Add New User',
    onboardingChecklist: 'Edit onboarding checklist',
    editOnboardingChecklist: 'Edit onboarding checklist',
    onboardingChecklistEmpty: 'No checklist yet',
    onboardingChecklistEmptyDesc: 'Add items below and save to create the first version of your onboarding checklist.',
    onboardingChecklistItemPlaceholder: 'Checklist item',
    addChecklistItem: 'Add item',
    saveChecklist: 'Save checklist',
    checklistSaved: 'Onboarding checklist saved',
    failedToSaveChecklist: 'Failed to save checklist',
    failedToLoadChecklist: 'Failed to load checklist',
    studentOnboardingChecklist: 'Onboarding checklist',
    checklistProgress: '{checked} of {total}',
    useLatestOnboardingChecklist: 'Use latest',
    useLatestOnboardingChecklistInfo: 'Switch this student to the latest checklist.',
    noChecklistCreatedYet: 'Create an onboarding checklist first using the button at the top of this page.',
    generateSignupLink: 'Generate Signup Link',
    paymentDue: 'Payment Due',
    weeklyPayment: 'Weekly Payment',
    monthlyPayment: 'Monthly Payment',
    paymentLink: 'Payment Link',
    addPaymentLink: 'Add payment link',
    noPaymentLink: 'No payment link available',
    amount: 'Amount',
    goToPaymentApp: 'Go to Payment Portal',
    paymentDueBannerOverdue: 'Your payment is overdue',
    paymentDueBannerDueToday: 'Your payment is due today',
    paymentDueBannerDueSoon: 'Your payment is due in {days} days',
    paymentDueBannerViewDetails: 'View details',
    paymentDueBannerPayNow: 'Pay now',
    paymentStatusOverdue: 'Overdue',
    paymentStatusDueToday: 'Due today',
    paymentStatusDueSoon: 'Due soon',

    // Admin Payments
    paymentsDueDescription: 'View and manage payment emails for students',
    selectPaymentsToSendEmails: 'Please select payments to send emails',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    sendingEmails: 'Sending...',
    sendEmails: 'Send Emails',
    noPaymentsDue: 'No payments due',
    noPaymentsDueDescription: 'There are currently no payments due for email reminders',
    student: 'student',
    paymentSelected: 'payment selected',
    paymentsSelected: 'payments selected',
    readyToSendEmails: ' ready to send emails',
    clearSelection: 'Clear Selection',

    // Days of Week - Short Names
    sundayShort: 'Sun',
    mondayShort: 'Mon',
    tuesdayShort: 'Tue',
    wednesdayShort: 'Wed',
    thursdayShort: 'Thu',
    fridayShort: 'Fri',
    saturdayShort: 'Sat',

    // Admin Schedule
    manageClasses: 'Manage Classes',
    addNewClass: 'Add New Class',
    createNewClass: 'Create New Class',
    dayAndTime: 'Day & Time',
    courseType: 'Course Type',
    startDate: 'Start Date',
    endDate: 'End Date',
    classStartDate: 'Class Start Date',
    actions: 'Actions',
    optional: 'Optional',
    selectStudents: 'Select students...',
    noStudentsAssigned: 'No students assigned',
    pending: 'Pending',
    unknownEmail: 'Unknown Email',
    classNotFound: 'Class not found',
    invalidField: 'Invalid field',
    updateSuccessful: 'Update successful',
    updateFailed: 'Update failed',
    noNotes: 'No notes',
    noEndDate: 'No end date',

    // Admin Users
    teacherAccount: 'Teacher Account',
    adminAccount: 'Admin Account',
    enterFullName: 'Enter full name',
    enterEmailAddress: 'Enter email address',
    userStatus: 'Status',
    activeUser: 'User',
    pendingSignup: 'Pending Signup',
    copyLink: 'Copy Link',
    copySignupLink: 'Copy signup link',
    confirmDelete: 'Are you sure you want to delete {name} ({email})?',
    signupLinkCopied: 'Signup link copied to clipboard. Link expires in 24 hours.',
    signupLinkExpires: 'Link expires in 24 hours. Copying the link extends the expiration date.',
    failedToCopyLink: 'Failed to copy signup link',
    pleaseEnterNameEmail: 'Please fill in both name and email',
    failedToGenerateLink: 'Failed to generate signup link',
    failedToFetchUsers: 'Failed to fetch users',
    failedToDeleteUser: 'Failed to delete user',
    cannotDeleteOwnAccount: 'Cannot delete your own account',
    userNotFound: 'User not found',
    userDeleted: 'User and associated data deleted successfully',
    unauthorizedAction: 'Unauthorized action',
    pleaseEnterName: 'Please enter a name',
    enterName: 'Enter name',
    nameUpdated: 'Name updated successfully',
    failedToUpdateName: 'Failed to update name',
    birthdateUpdated: 'Birthdate updated successfully',
    failedToUpdateBirthdate: 'Failed to update birthdate',
    copy: 'Copy',

    // URL Validation
    invalidUrl: 'URL must start with http:// or https://',

    // Payment Completion
    completed: 'Completed',
    markAsCompleted: 'Mark as Completed',
    classSchedule: 'Class Schedule',
    allPaymentsCompleted: 'All payments completed',
    markAsIncomplete: 'Mark as Incomplete',
    processing: 'Processing...',
    paymentCompleted: 'Payment Completed',
    completedOn: 'Completed on',
    confirm: 'Confirm',
    selectCompletionDate: 'Select Completion Date',

    // Admin Schedule Errors and Success Messages
    admin: {
      schedule: {
        errors: {
          selectStudent: 'Please select at least one student for the class',
          addSchedule: 'Please add at least one schedule',
          monthlyPaymentDate: 'Monthly payments must start on the 1st, 15th, or last day of the month',
          contractUpload: 'Failed to upload contract file',
          createClass: 'Failed to create class',
          deleteClass: 'Failed to delete class'
        },
        success: {
          classCreated: 'Class created successfully',
          classDeleted: 'Class deleted successfully'
        },
        confirmDelete: 'Are you sure you want to delete this class?',
        pinnedLinks: 'Pinned links',
        pinnedLinksOptional: 'Pinned links (optional)',
        pinnedLinksDescription: 'Links shown to students above their schedule.',
        addLink: 'Add link',
        pinnedLinkPlaceholder: 'https://...',
        pinnedLinkTitleLabel: 'Title (optional)'
      }
    },

    // Timezones
    timezones: {
      eastern: 'Eastern Time (ET)',
      central: 'Central Time (CT)',
      mountain: 'Mountain Time (MT)',
      pacific: 'Pacific Time (PT)',
      brasilia: 'Brasília Time (BRT)',
      gmt: 'Greenwich Mean Time (GMT)',
      cet: 'Central European Time (CET)',
      msk: 'Moscow Standard Time (MSK)',
      jst: 'Japan Standard Time (JST)',
      cst: 'China Standard Time (CST)',
      aet: 'Australian Eastern Time (AET)',
      local: 'Local Time'
    },

    timezone: 'Timezone',
    classTimesDisplayed: 'Class times will be displayed in this timezone',
    studentsSeeTimesConverted: 'Students will see times converted to their local timezone',
    onlySelectedDates: 'Only',
    selectedFile: 'Selected file',
    everyXNumberWeeks: 'Every X number of weeks',
    onceAMonth: 'Once a month',
    forMonthlyPayments: 'For monthly payments',
    startDateMustBe1st15thOrLastDayOfMonth: 'Start date must be the 1st, 15th, or last day of the month',

    paymentFrequency: 'Payment Frequency',
    every: 'Every',
    week: 'week',
    weeks: 'weeks',
    autoSet: 'auto-set',
    paymentDayAutoSet: 'Payment day is automatically set based on the selected payment start date',
    enterURLWhereStudentsCanMakePayments: 'Enter a URL where students can make payments',
    currency: 'Currency',
    currencyBRL: 'BRL',
    currencyUSD: 'USD',
    currencyEUR: 'EUR',

    // Class Plans
    templateLibrary: 'Template Library',
    noTemplatesAvailable: 'No templates available',
    templateDescription: 'Template Description',
    createTemplate: 'Create Template',
    templateName: 'Template Name',
    enterTemplateName: 'Enter Template Name',
    applyTemplate: 'Apply Template',
    applyToClassPlan: 'Apply to Class Plan',
    templateCreated: 'Template Created',
    templateDeleted: 'Template Deleted',
    templateUpdated: 'Template Updated',
    templateItems: 'Template Items',
    noItemsInTemplate: 'No items in template',
    topLevelItems: 'Top Level Items',
    moreItems: 'More Items',
    createdBy: 'Created By',
    addFirstItem: 'Add First Item',
    noClassPlan: 'No Class Plan',
    addNewItem: 'Add New Item',
    editItem: 'Edit Item',
    itemTitle: 'Item Title',
    itemDescription: 'Item Description',
    enterItemTitle: 'Enter Item Title',
    enterItemDescription: 'Enter Item Description',
    saveChanges: 'Save Changes',
    addChildItem: 'Add Sub-Item',
    insertItemAbove: 'Insert Item Above',
    deleteClassPlan: 'Delete Class Plan',
    deleteClassPlanWarning: 'Are you sure you want to delete this class plan?',
    deleteClassPlanConfirm: 'Are you sure you want to delete this class plan?',
    monthlyView: 'Monthly View',
    allPlans: 'All Plans',
    selectStudent: 'Select Student',
    noClassPlansExist: 'No class plans exist',
    switchToMonthlyView: 'Switch to Monthly View',
    itemsCompleted: 'Items Completed',
    noItemsInPlan: 'No items in plan',
    addItemToGetStarted: 'Add item to get started',
    planFor: 'Plan For',
    insertAbove: 'Insert Above',
    expandCollapse: 'Expand/Collapse',
    itemMarkedCompleted: 'Item marked as completed',
    itemMarkedIncomplete: 'Item marked as incomplete',
    templateApplied: 'Template Applied',
    itemAdded: 'Item Added',
    itemUpdated: 'Item Updated',
    itemDeleted: 'Item Deleted',
    childItemAdded: 'Child Item Added',
    itemInserted: 'Item Inserted',
    noTemplatesYet: 'No templates yet',
    templateReuse: 'Template Reuse',
    editTemplate: 'Edit Template',
    viewTemplate: 'View Template',
    templateStructureNote: 'For more complex changes to template structure, apply the template to a class plan, make your changes there, and save it as a new template.',

    // Homework
    homework: 'Homework',
    addHomework: 'Add Homework',
    noHomework: 'No homework',
    homeworkTitle: 'Title',
    homeworkDescription: 'Description',
    allowTextSubmission: 'Allow text submission',
    allowFileSubmission: 'Allow file submission',
    submissionType: 'Submission Type',
    dueDate: 'Due Date',
    noHomeworkAssignments: 'No homework assignments found.',
    homeworkSubmissions: 'Student Submissions',
    noSubmissionsYet: 'No submissions yet.',
    submittedOn: 'Submitted on',
    grade: 'Grade',
    feedback: 'Feedback',
    submitFeedback: 'Submit Feedback',
    upcoming: 'Upcoming',
    past: 'Past',
    upcomingHomework: 'Upcoming Homework',
    pastHomework: 'Past Homework',
    noUpcomingHomework: 'No upcoming homework assignments.',
    noPastHomework: 'No past homework assignments.',
    yourHomework: 'Your Homework',
    fileDeleted: 'File deleted successfully',
    deleteFile: 'Delete File',

    // Class Exceptions
    exceptions: {
      cancelClass: 'Cancel Class',
      rescheduleClass: 'Reschedule Class',
      cancelledClass: 'Cancelled',
      rescheduledFrom: 'Rescheduled from',
      rescheduledTo: 'Rescheduled to',
      rescheduledClass: 'Rescheduled Class',
      reason: 'Reason',
      enterReason: 'Enter reason (optional)',
      newDateTime: 'New Date & Time',
      selectNewDate: 'Select new date',
      selectNewTime: 'Select new time',
      confirmCancel: 'Are you sure you want to cancel this class?',
      confirmReschedule: 'Confirm reschedule',
      classCancelled: 'Class cancelled successfully',
      classRescheduled: 'Class rescheduled successfully',
      deleteException: 'Delete Exception',
      confirmDeleteException: 'Are you sure you want to delete this exception?',
      exceptionDeleted: 'Exception deleted successfully',
      noExceptions: 'No exceptions',
      manageExceptions: 'Manage Exceptions',
      originalDate: 'Original Date',
      newDate: 'New Date',
      type: 'Type',
      modifyClass: 'Modify Class',
    },
  },
  'pt-BR': {
    // Auth & Profile
    login: 'Entrar',
    signup: 'Cadastrar',
    logout: 'Sair',
    profile: 'Perfil',
    name: 'Nome',
    email: 'Email',
    password: 'Senha',
    confirmPassword: 'Confirmar Senha',
    newPassword: 'Nova Senha',
    updateProfile: 'Atualizar Perfil',
    profileUpdated: 'Perfil atualizado com sucesso',
    language: 'Idioma',
    birthdate: 'Data de Nascimento',
    birthdateFormat: 'MM-DD',
    birthday: 'Aniversário',
    birthdays: 'Aniversários',
    happyBirthdayGreeting: 'Feliz aniversário, {name}!',
    happyBirthdayGeneric: 'Feliz aniversário!',
    happyBirthdaySubtext: 'Desejamos um dia maravilhoso para você!',
    happyBirthdayCalendarPill: 'Feliz aniversário!',
    birthdayClose: 'Fechar',
    holiday: 'Feriado',
    holidays: 'Feriados',
    holidayNewYearsDay: 'Ano Novo',
    holidayMartinLutherKingJrDay: 'Dia de Martin Luther King Jr.',
    holidayPresidentsDay: 'Dia dos Presidentes',
    holidayMemorialDay: 'Dia da Memória',
    holidayJuneteenth: 'Juneteenth',
    holidayIndependenceDay: 'Dia da Independência',
    holidayLaborDay: 'Dia do Trabalho',
    holidayVeteransDay: 'Dia dos Veteranos',
    holidayThanksgiving: 'Ação de Graças',
    holidayChristmasDay: 'Natal',
    emailNotEditable: 'O email não pode ser editado. Para alterar o email, o usuário deve ser excluído e recriado com o email correto.',
    amountPaid: 'Valor pago',
    amountDue: 'Valor a pagar',
    profilePicture: 'Foto de Perfil',
    uploadProfilePicture: 'Enviar Foto de Perfil',
    deleteProfilePicture: 'Excluir Foto de Perfil',
    changeProfilePicture: 'Alterar Foto de Perfil',
    profilePictureUploaded: 'Foto de perfil enviada com sucesso',
    profilePictureDeleted: 'Foto de perfil excluída com sucesso',
    profilePictureError: 'Erro ao enviar foto de perfil',
    selectImage: 'Selecionar Imagem',
    confirmDeleteProfilePicture: 'Tem certeza que deseja excluir sua foto de perfil?',
    yourContracts: 'Seus Contratos',

    // Navigation
    dashboard: 'Painel',
    home: 'Início',
    schedule: 'Agenda',
    classMaterials: 'Materiais de Aula',
    adminPanel: 'Painel Admin',
    manageUsers: 'Usuários',
    manageSchedules: 'Aulas',
    manageMaterials: 'Gerenciar Materiais',
    contentLibrary: 'Biblioteca de Conteúdo',
    myContent: 'Meu Conteúdo',
    classPlans: 'Planos de Aula',
    attendance: 'Presença',
    contentLibraryTitle: 'Biblioteca de Conteúdo',
    myContentTitle: 'Meu Conteúdo',
    myContentIntro: 'Conteúdo que seu professor compartilhou com você.',
    myContentEmpty: 'Nada compartilhado ainda',
    myContentEmptyDesc: 'Seu professor adicionará conteúdo aqui para você.',
    myContentView: 'Ver',
    addContent: 'Adicionar conteúdo',
    contentLibraryEmpty: 'Nenhum conteúdo ainda',
    contentLibraryEmptyDesc: 'Adicione vídeos, texto, imagens ou links para seus alunos visualizarem.',
    contentLibraryAudience: 'Público',
    allStudents: 'Todos os alunos',
    deleteContentConfirm: 'Excluir este item?',
    typeVideo: 'Vídeo',
    typeText: 'Texto',
    typeImage: 'Imagem',
    loadMore: 'Carregar mais',
    youtubeUrlPlaceholder: 'Cole a URL do YouTube',
    titleLabel: 'Título',
    descriptionLabel: 'Descrição',
    audienceLabel: 'Quem pode ver',
    contentLibraryComments: 'Comentários',
    comments: 'Comentários',
    addComment: 'Adicionar comentário',
    reply: 'Responder',
    commentPlaceholder: 'Escreva um comentário…',
    noComments: 'Nenhum comentário ainda',
    commentEdited: 'Editado',
    commentDeleted: '[Excluído]',
    commentAuthorUnknown: 'Usuário desconhecido',
    you: 'Você',
    
    // Dashboard
    quickActions: 'Ações Rápidas',
    manageScheduleDesc: 'Criar ou editar sessões de aula',
    classMaterialsDesc: 'Carregar e gerenciar materiais',
    upcomingClasses: "Próximas Aulas desta Semana",
    pastClasses: "Aulas Passadas desta Semana",
    viewAll: 'Ver Tudo',
    yourUpcomingClasses: 'Suas Próximas Aulas',
    sunday: 'Domingo',
    monday: 'Segunda-feira',
    tuesday: 'Terça-feira',
    wednesday: 'Quarta-feira',
    thursday: 'Quinta-feira',
    friday: 'Sexta-feira',
    saturday: 'Sábado',
    class: 'Aula',
    classes: 'Aulas',
    noClassesScheduled: 'Nenhuma aula agendada para este dia',
    students: 'Alunos',
    pair: 'Aula em Dupla',
    group: 'Aula em Grupo',
    calendar: 'Calendário',
    previous: 'Anterior',
    next: 'Próximo',
    noUpcomingClasses: 'Sem aulas futuras',
    noPastClasses: 'Sem aulas passadas',
    paymentsDue: 'Pagamentos Pendentes',
    classOn: 'Aula em',
    materials: 'Materiais',
    slides: 'Slides',
    dayDetails: 'Detalhes do Dia',
    noDetailsAvailable: 'Nenhum detalhe disponível',
    nothingScheduledForThisDay: 'Não há nada agendado para este dia.',
    days: 'Dias',
    markAbsent: 'Marcar ausente',
    absent: 'Ausente',
    attendanceTitle: 'Presença',
    attendanceDescription: 'Veja quem esteve presente em cada aula.',
    attended: 'Presente',
    missed: 'Faltou',
    focusStudents: 'Focar em alunos',
    last7Days: 'Últimos 7 dias',
    last30Days: 'Últimos 30 dias',
    last90Days: 'Últimos 90 dias',
    dateRangeAll: 'Tudo',
    sessionsCount: 'Aulas',
    attendancePercent: 'Presença %',
    studentsWithAbsences: 'Alunos com faltas',
    atRisk: 'Em risco',
    attendanceEmptyState: 'Nenhuma presença neste período. Marque as faltas no Painel para cada aula.',
    attendanceEmptyCta: 'Marcar faltas no Painel',
    onlyStudentsWithAbsences: 'Só alunos com pelo menos uma falta',
    
    // Schedule
    courseSchedule: 'Agenda de Aulas',
    scheduleDescription: 'Visualize e gerencie sua agenda de aulas.',
    previousMonth: 'Mês Anterior',
    nextMonth: 'Próximo Mês',
    weeklyScheduleSummary: 'Resumo Semanal',
    studentsLabel: 'Alunos',
    dayOfWeek: 'Dia',
    date: 'Data',
    time: 'Horário',
    notes: 'Observações',
    notesInfo: 'Observações serão compartilhadas com os alunos',
    privateNotes: 'Observações privadas',
    privateNotesInfo: 'Observações privadas não serão compartilhadas com os alunos',
    selectDayToViewDetails: 'Selecione um dia para ver os detalhes da aula',
    scheduleMaterialFileFallback: 'Documento',
    availableClassDates: 'Datas de aula disponíveis',
    linksPinnedByTeacher: 'Links fixados pelo seu professor',
    usefulLinksForYou: 'Links úteis para você',
    opensInNewTab: 'abre em nova aba',
    
    // Class Materials
    classMaterialsTitle: 'Gerenciamento de Materiais de Aula',
    selectMonthLabel: 'Selecionar Mês',
    selectDateLabel: 'Selecionar Data',
    selectClass: 'Selecionar Aula',
    uploadMaterials: 'Carregar Materiais',
    addLinkPlaceholder: 'Adicionar um link para materiais de aprendizado',
    uploading: 'Carregando...',
    existingMaterials: 'Materiais Existentes',
    materialsForDate: 'Materiais para',
    selectDateWithClass: 'Selecione uma data com uma aula agendada para gerenciar materiais',
    pleaseLogin: 'Por favor, faça login para ver seus materiais de aula.',
    failedToLoad: 'Falha ao carregar materiais de aula',
    usefulLinks: 'Links Úteis',
    noMaterialsFound: 'Nenhum material encontrado',
    downloadSlides: 'Baixar Slides',
    noMaterialsAvailable: 'Nenhum material disponível',
    addMaterials: 'Adicionar materiais',
    
    // Common
    save: 'Salvar',
    cancel: 'Cancelar',
    edit: 'Editar',
    delete: 'Excluir',
    add: 'Adicionar',
    loading: 'Carregando...',
    error: 'Erro',
    success: 'Sucesso',
    saving: 'Salvando...',
    of: 'de',
    page: 'Página',
    total: 'total',

    // Payment Configuration
    paymentConfiguration: 'Configuração de Pagamento',
    weeklyInterval: 'Intervalo Semanal',
    selectPaymentDay: 'Dia de Pagamento',
    firstDayMonth: 'Primeiro dia do mês',
    fifteenthDayMonth: 'Dia 15 do mês',
    lastDayMonth: 'Último dia do mês',
    pleaseSpecifyWeeklyInterval: 'Por favor, especifique o intervalo semanal',
    pleaseSelectPaymentDay: 'Por favor, selecione o dia de pagamento',
    paymentStartDate: 'Data de Início do Pagamento',
    addNewUser: 'Adicionar Novo Usuário',
    onboardingChecklist: 'Editar checklist de integração',
    editOnboardingChecklist: 'Editar checklist de integração',
    onboardingChecklistEmpty: 'Nenhum checklist ainda',
    onboardingChecklistEmptyDesc: 'Adicione itens abaixo e salve para criar a primeira versão do checklist de integração.',
    onboardingChecklistItemPlaceholder: 'Item do checklist',
    addChecklistItem: 'Adicionar item',
    saveChecklist: 'Salvar checklist',
    checklistSaved: 'Checklist de integração salvo',
    failedToSaveChecklist: 'Falha ao salvar o checklist',
    failedToLoadChecklist: 'Falha ao carregar o checklist',
    studentOnboardingChecklist: 'Checklist de integração',
    checklistProgress: '{checked} de {total}',
    useLatestOnboardingChecklist: 'Usar mais recente',
    useLatestOnboardingChecklistInfo: 'Muda este aluno para o checklist mais recente.',
    noChecklistCreatedYet: 'Crie um checklist de integração primeiro usando o botão no topo desta página.',
    generateSignupLink: 'Gerar Link de Cadastro',
    paymentDue: 'Pagamento Pendente',
    weeklyPayment: 'Pagamento Semanal',
    monthlyPayment: 'Pagamento Mensal',
    paymentLink: 'Link de Pagamento',
    addPaymentLink: 'Adicionar link de pagamento',
    noPaymentLink: 'Link de pagamento não disponível',
    amount: 'Valor',
    goToPaymentApp: 'Ir para Portal de Pagamento',
    paymentDueBannerOverdue: 'Seu pagamento está atrasado',
    paymentDueBannerDueToday: 'Seu pagamento vence hoje',
    paymentDueBannerDueSoon: 'Seu pagamento vence em {days} dias',
    paymentDueBannerViewDetails: 'Ver detalhes',
    paymentDueBannerPayNow: 'Pagar agora',
    paymentStatusOverdue: 'Atrasado',
    paymentStatusDueToday: 'Vence hoje',
    paymentStatusDueSoon: 'Vence em breve',

    // Admin Payments
    paymentsDueDescription: 'Visualize e gerencie emails de pagamento para alunos',
    selectPaymentsToSendEmails: 'Por favor, selecione pagamentos para enviar emails',
    selectAll: 'Selecionar Todos',
    deselectAll: 'Desselecionar Todos',
    sendingEmails: 'Enviando...',
    sendEmails: 'Enviar Emails',
    noPaymentsDue: 'Nenhum pagamento pendente',
    noPaymentsDueDescription: 'Não há pagamentos pendentes para lembretes por email no momento',
    student: 'aluno',
    paymentSelected: 'pagamento selecionado',
    paymentsSelected: 'pagamentos selecionados',
    readyToSendEmails: ' prontos para enviar emails',
    clearSelection: 'Limpar Seleção',

    // Days of Week - Short Names
    sundayShort: 'Dom',
    mondayShort: 'Seg',
    tuesdayShort: 'Ter',
    wednesdayShort: 'Qua',
    thursdayShort: 'Qui',
    fridayShort: 'Sex',
    saturdayShort: 'Sáb',

    // Admin Schedule
    manageClasses: 'Gerenciar Aulas',
    addNewClass: 'Adicionar Nova Aula',
    createNewClass: 'Criar Nova Aula',
    dayAndTime: 'Dia e Horário',
    courseType: 'Tipo de Aula',
    startDate: 'Data de Início',
    endDate: 'Data de Término',
    classStartDate: 'Data de Início da Aula',
    actions: 'Ações',
    optional: 'Opcional',
    selectStudents: 'Selecionar alunos...',
    noStudentsAssigned: 'Nenhum aluno atribuído',
    pending: 'Pendente',
    unknownEmail: 'Email Desconhecido',
    classNotFound: 'Aula não encontrada',
    invalidField: 'Campo inválido',
    updateSuccessful: 'Atualização bem-sucedida',
    updateFailed: 'Falha na atualização',
    noNotes: 'Sem notas',
    noEndDate: 'Sem data de término',

    // Admin Users
    teacherAccount: 'Conta de Professor',
    adminAccount: 'Conta de Administrador',
    enterFullName: 'Digite o nome completo',
    enterEmailAddress: 'Digite o endereço de e-mail',
    userStatus: 'Status',
    activeUser: 'Usuário',
    pendingSignup: 'Cadastro Pendente',
    copyLink: 'Copiar Link',
    copySignupLink: 'Copiar link de cadastro',
    confirmDelete: 'Tem certeza que deseja excluir {name} ({email})?',
    signupLinkCopied: 'Link de cadastro copiado para a área de transferência. Link expira em 24 horas.',
    signupLinkExpires: 'O link expira em 24 horas. Copiar o link estende a data de expiração.',
    failedToCopyLink: 'Falha ao copiar link de cadastro',
    pleaseEnterNameEmail: 'Por favor, preencha nome e email',
    failedToGenerateLink: 'Falha ao gerar link de cadastro',
    failedToFetchUsers: 'Falha ao buscar usuários',
    failedToDeleteUser: 'Falha ao excluir usuário',
    cannotDeleteOwnAccount: 'Não é possível excluir sua própria conta',
    userNotFound: 'Usuário não encontrado',
    userDeleted: 'Usuário e dados associados excluídos com sucesso',
    unauthorizedAction: 'Ação não autorizada',
    pleaseEnterName: 'Por favor, insira um nome',
    enterName: 'Digite o nome',
    nameUpdated: 'Nome atualizado com sucesso',
    failedToUpdateName: 'Falha ao atualizar nome',
    birthdateUpdated: 'Data de nascimento atualizada com sucesso',
    failedToUpdateBirthdate: 'Falha ao atualizar data de nascimento',
    copy: 'Copiar',

    // URL Validation
    invalidUrl: 'URL deve começar com http:// ou https://',

    // Payment Completion
    completed: 'Concluído',
    markAsCompleted: 'Marcar como Concluído',
    classSchedule: 'Horário das Aulas',
    allPaymentsCompleted: 'Todos os pagamentos concluídos',
    markAsIncomplete: 'Marcar como Não Concluído',
    processing: 'Processando...',
    paymentCompleted: 'Pagamento Concluído',
    completedOn: 'Concluído em',
    confirm: 'Confirmar',
    selectCompletionDate: 'Selecionar Data de Conclusão',

    // Admin Schedule Errors and Success Messages
    admin: {
      schedule: {
        errors: {
          selectStudent: 'Por favor, selecione pelo menos um aluno para a aula',
          addSchedule: 'Por favor, adicione pelo menos um horário',
          monthlyPaymentDate: 'Pagamentos mensais devem começar no dia 1, 15 ou último dia do mês',
          contractUpload: 'Falha ao fazer upload do arquivo do contrato',
          createClass: 'Falha ao criar aula',
          deleteClass: 'Falha ao excluir aula'
        },
        success: {
          classCreated: 'Aula criada com sucesso',
          classDeleted: 'Aula excluída com sucesso'
        },
        confirmDelete: 'Tem certeza que deseja excluir esta aula?',
        pinnedLinks: 'Links fixados',
        pinnedLinksOptional: 'Links fixados (opcional)',
        pinnedLinksDescription: 'Links exibidos aos alunos acima da agenda.',
        addLink: 'Adicionar link',
        pinnedLinkPlaceholder: 'https://...',
        pinnedLinkTitleLabel: 'Título (opcional)'
      }
    },

    // Timezones
    timezones: {
      eastern: 'Horário do Leste (ET)',
      central: 'Horário Central (CT)',
      mountain: 'Horário das Montanhas (MT)',
      pacific: 'Horário do Pacífico (PT)',
      brasilia: 'Horário de Brasília (BRT)',
      gmt: 'Horário de Greenwich (GMT)',
      cet: 'Horário da Europa Central (CET)',
      msk: 'Horário de Moscou (MSK)',
      jst: 'Horário do Japão (JST)',
      cst: 'Horário da China (CST)',
      aet: 'Horário da Austrália Oriental (AET)',
      local: 'Horário Local'
    },

    timezone: 'Fuso horário',
    classTimesDisplayed: 'Os horários das aulas serão exibidos neste fuso horário',
    studentsSeeTimesConverted: 'Os alunos verão os horários convertidos para seu fuso horário local',
    onlySelectedDates: 'Apenas',
    selectedFile: 'Arquivo selecionado',
    everyXNumberWeeks: 'A cada X semanas',
    onceAMonth: 'Uma vez por mês',
    forMonthlyPayments: 'Para pagamentos mensais',
    startDateMustBe1st15thOrLastDayOfMonth: 'A data de início deve ser o 1º, 15º ou último dia do mês',

    paymentFrequency: 'Frequência de Pagamento',
    every: 'A cada',
    week: 'semana',
    weeks: 'semanas',
    autoSet: 'automático',
    paymentDayAutoSet: 'O dia do pagamento é definido automaticamente com base na data de início selecionada',
    enterURLWhereStudentsCanMakePayments: 'Digite uma URL onde os alunos podem fazer pagamentos',
    currency: 'Moeda',
    currencyBRL: 'BRL',
    currencyUSD: 'USD',
    currencyEUR: 'EUR',

    // Class Plans
    templateLibrary: 'Biblioteca de Modelos',
    noTemplatesAvailable: 'Nenhum modelo disponível',
    templateDescription: 'Descrição do Modelo',
    createTemplate: 'Criar Modelo',
    templateName: 'Nome do Modelo',
    enterTemplateName: 'Digite o Nome do Modelo',
    applyTemplate: 'Aplicar Modelo',
    applyToClassPlan: 'Aplicar ao Plano de Aula',
    templateCreated: 'Modelo Criado',
    templateDeleted: 'Modelo Excluído',
    templateUpdated: 'Modelo Atualizado',
    templateItems: 'Itens do Modelo',
    noItemsInTemplate: 'Nenhum item no modelo',
    topLevelItems: 'Itens de Nível Superior',
    moreItems: 'Mais Itens',
    createdBy: 'Criado Por',
    addFirstItem: 'Adicionar Primeiro Item',
    noClassPlan: 'Nenhum Plano de Aula',
    addNewItem: 'Adicionar Novo Item',
    editItem: 'Editar Item',
    itemTitle: 'Título do Item',
    itemDescription: 'Descrição do Item',
    enterItemTitle: 'Digite o Título do Item',
    enterItemDescription: 'Digite a Descrição do Item',
    saveChanges: 'Salvar Alterações',
    addChildItem: 'Adicionar Subtopico',
    insertItemAbove: 'Inserir Item Acima',
    deleteClassPlan: 'Excluir Plano de Aula',
    deleteClassPlanWarning: 'Tem certeza que deseja excluir este plano de aula?',
    deleteClassPlanConfirm: 'Tem certeza que deseja excluir este plano de aula?',
    monthlyView: 'Visualização Mensal',
    allPlans: 'Todos os Planos',
    selectStudent: 'Selecionar Aluno',
    noClassPlansExist: 'Nenhum plano de aula existente',
    switchToMonthlyView: 'Alternar para Visualização Mensal',
    itemsCompleted: 'Itens Concluídos',
    noItemsInPlan: 'Nenhum item no plano',
    addItemToGetStarted: 'Adicionar item para começar',
    planFor: 'Plano Para',
    insertAbove: 'Inserir Acima',
    expandCollapse: 'Expandir/Recolher',
    itemMarkedCompleted: 'Item marcado como concluído',
    itemMarkedIncomplete: 'Item marcado como não concluído',
    templateApplied: 'Modelo Aplicado',
    itemAdded: 'Item Adicionado',
    itemUpdated: 'Item Atualizado',
    itemDeleted: 'Item Excluído',
    childItemAdded: 'Item Filho Adicionado',
    itemInserted: 'Item Inserido',
    noTemplatesYet: 'Nenhum modelo disponível ainda',
    templateReuse: 'Reutilizar Modelo',
    editTemplate: 'Editar Modelo',
    viewTemplate: 'Visualizar Modelo',
    templateStructureNote: 'Para alterações mais complexas na estrutura do modelo, aplique o modelo a um plano de aula, faça suas alterações lá e salve como um novo modelo.',

    // Homework
    homework: 'Lição de Casa',
    addHomework: 'Adicionar Lição',
    noHomework: 'Nenhuma lição atribuída',
    homeworkTitle: 'Título da Lição',
    homeworkDescription: 'Descrição',
    allowTextSubmission: 'Permitir resposta em texto',
    allowFileSubmission: 'Permitir envio de arquivos',
    submissionType: 'Tipo de Envio',
    dueDate: 'Data de Entrega',
    noHomeworkAssignments: 'Nenhuma lição atribuída',
    homeworkSubmissions: 'Envios dos Alunos',
    noSubmissionsYet: 'Nenhum envio ainda',
    submittedOn: 'Enviado em',
    grade: 'Nota',
    feedback: 'Feedback',
    submitFeedback: 'Enviar Feedback',
    upcoming: 'Próximas',
    past: 'Passadas',
    upcomingHomework: 'Próximas Lições',
    pastHomework: 'Lições Passadas',
    noUpcomingHomework: 'Nenhuma lição futura',
    noPastHomework: 'Nenhuma lição passada',
    yourHomework: 'Suas Lições',
    fileDeleted: 'Arquivo excluído com sucesso',
    deleteFile: 'Excluir Arquivo',

    // Class Exceptions
    exceptions: {
      cancelClass: 'Cancelar Aula',
      rescheduleClass: 'Reagendar Aula',
      cancelledClass: 'Cancelada',
      rescheduledFrom: 'Reagendada de',
      rescheduledTo: 'Reagendada para',
      rescheduledClass: 'Aula Reagendada',
      reason: 'Motivo',
      enterReason: 'Digite o motivo (opcional)',
      newDateTime: 'Nova Data e Horário',
      selectNewDate: 'Selecione a nova data',
      selectNewTime: 'Selecione o novo horário',
      confirmCancel: 'Tem certeza que deseja cancelar esta aula?',
      confirmReschedule: 'Confirmar reagendamento',
      classCancelled: 'Aula cancelada com sucesso',
      classRescheduled: 'Aula reagendada com sucesso',
      deleteException: 'Excluir Exceção',
      confirmDeleteException: 'Tem certeza que deseja excluir esta exceção?',
      exceptionDeleted: 'Exceção excluída com sucesso',
      noExceptions: 'Sem exceções',
      manageExceptions: 'Gerenciar Exceções',
      originalDate: 'Data Original',
      newDate: 'Nova Data',
      type: 'Tipo',
      modifyClass: 'Modificar Aula',
    },
  }
};

export const useTranslation = (language: Language) => {
  return translations[language];
}; 